import { useState } from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent } from "@design-lab/shared/ui/tooltip";
import { remoteImageStaticUrl } from "common/utils/remote-image";

const TOOLTIP_WIDTH = "320px";
const TOOLTIP_DELAY = 300;

export function PreCutInfoTooltip() {
  const [isHintOpen, setIsHintOpen] = useState(false);

  const handleOpen = () => setIsHintOpen(true);

  return (
    <Tooltip open={isHintOpen} delayDuration={TOOLTIP_DELAY} onOpenChange={setIsHintOpen}>
      <TooltipTrigger asChild data-testid="pre-cut-info-tooltip">
        <button
          type="button"
          onClick={handleOpen}
          className="inline-flex items-center justify-center text-gray-600 transition-colors hover:text-gray-800"
          aria-label="Pre-cut information"
          data-testid="pre-cut-info-button"
        >
          <Info className="size-4" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        className="bg-background text-primary rounded-lg border border-gray-200 p-3 text-sm shadow-lg"
        style={{ width: TOOLTIP_WIDTH }}
        showArrow={false}
        side="top"
        align="center"
        sideOffset={10}
      >
        <div className="flex flex-col">
          <div className="mb-3 text-base font-bold">🔍 What&apos;s pre-cut?</div>
          <p className="mb-3 text-sm font-normal">
            Pre-cut transfers are ready to apply right out of the package—no trimming required!
            <br />
            This ensures a faster, cleaner application every time.
          </p>

          <div className="flex h-[234px] flex-row justify-between gap-3">
            {/* No Pre-cut */}
            <div className="flex h-full flex-col justify-between">
              <div>
                <div className="mb-3 h-[168px] w-[142px]">
                  <img
                    src={remoteImageStaticUrl("gen/pre-cut-tooltip/no-pre-cut.jpeg")}
                    alt="No Pre-cut"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="mb-[9px] text-sm font-bold">No Pre-cut</div>
              </div>
              <div>
                <div className="text-xs">Time per 10 transfers:</div>
                <div className="text-xs font-bold">10 minutes</div>
              </div>
            </div>

            {/* Pre-cut */}
            <div className="flex h-full flex-col justify-between">
              <div>
                <div className="mb-3 h-[168px] w-[142px]">
                  <img
                    src={remoteImageStaticUrl("gen/pre-cut-tooltip/pre-cut.png")}
                    alt="Pre-cut"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="mb-[9px] text-sm font-bold">Pre-cut</div>
              </div>
              <div>
                <div className="text-xs">Time per 10 transfers:</div>
                <div className="text-xs font-bold text-green-600">0 minutes</div>
              </div>
            </div>
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
